export default "__VITE_ASSET__BMah6tDY__"